import { Fragment, memo } from "react";
import { Modal } from "react-bootstrap";

import dangerSvg from "../../Assets/Images/danger.svg";
import closeSvg from "../../Assets/Images/close.svg";
import errorSvg from "../../Assets/Images/error.svg";
import tickSvg from "../../Assets/Images/tick.svg";

import "./styles.css";

const ModalResult = (props) => {
  const { show, result, onClose } = props;
  return (
    <Modal show={show} centered={true}>
      <div className="modal-result">
        <img
          className="modal-result-status-img"
          src={
            !result?.dismissible
              ? result?.status === "success"
                ? tickSvg
                : dangerSvg
              : errorSvg
          }
        />
        <span className="modal-result-title">{result?.title}</span>
        <span className="modal-result-body">{result?.body}</span>
        {!result.dismissible ? (
          <Fragment>
            <button className="modal-result-btn" onClick={onClose}>
              تایید
            </button>
            <img
              className="modal-result-close"
              src={closeSvg}
              onClick={onClose}
            />
          </Fragment>
        ) : null}
      </div>
    </Modal>
  );
};
export default memo(ModalResult);
